<template>
  <div>
    <section class="bg-white relative z-10">
      <AtomsBanner
        :title="datas[component.activeVertical.value].title"
        :cover-image="datas[component.activeVertical.value].coverImage"
        class="max-w-8xl mx-auto px-4 md:px-8 lg:px-16"
      />
    </section>

    <section class="shadow-lg relative z-10">
      <ul class="max-w-8xl pb-3 md:pb-0 mx-auto px-4 md:px-8 lg:px-16 overflow-x-auto md:overflow-x-visible flex">
        <atoms-menu-item
          v-for="(menu, i) in guidesIndexLinks"
          :key="i"
          arrow
          theme="hover-with-border"
          :to="menu.url"
          :active="menu.name === component.activeVertical.value"
          :inner-wrapper-class="`text-semantic-surface-on-surface-variant hover:text-semantic-surface-on-surface !font-bold ${menu.name === component.activeVertical.value ? '!text-semantic-surface-on-surface' : ''}`"
          class="whitespace-nowrap"
        >
          {{ menu.label }}
        </atoms-menu-item>
      </ul>
    </section>

    <section>
      <div class="max-w-8xl mx-auto px-4 md:px-8 py-12 lg:py-16 lg:px-16">
        <div
          v-if="!_isEmpty(component.postsData.value)"
          class="flex flex-wrap -mx-3"
        >
          <div
            v-for="(post, postKey) in component.postsData.value"
            :key="postKey"
            class="w-full md:w-1/2 lg:w-1/3 px-4 mb-9"
          >
            <AtomsPost
              v-bind="post"
              :image-lazy-load="props.imageLazyLoad && (props.imageLazyLoadIgnoreMaxIndex <= postKey)"
            />
          </div>

          <div
            v-if="component.postsData.value.length < 1"
            class="w-full text-center font-bold text-lg"
          >
            <h1>
              No Post
            </h1>
          </div>
        </div>
        <!--<MoleculesPosts
          v-if="!_isEmpty(postsData)"
          :posts-data="postsData"
          :image-lazy-load="props.imageLazyLoad"
          :image-lazy-load-ignore-max-index="props.imageLazyLoadIgnoreMaxIndex"
        />-->

        <div
          v-if="(component.postsData.value.length < GET_MAX_POSTS) && (GET_MAX_POSTS > GET_POST_PERPAGE)"
          class="w-full text-center text-semantic-surface-on-surface px-3 mt-4"
        >
          <atoms-cta
            theme="tertiary"
            :full="false"
            align="center"
            size="medium"
            class="inline-flex items-center focus:text-semantic-surface-on-surface group"
            @click="postsStore.LOAD_POSTS"
          >
            View more guides
            <IconsChevron
              class="ml-3 transition-colors duration-200 fill-semantic-surface-on-surface group-hover:fill-semantic-primary-variant-light"
              direction="bottom"
              size="md"
            />
          </atoms-cta>
        </div>

        <!--<MoleculesCardCta
          class="mt-16 mb-8"
          :title="datas[vertical].cardCtaTitle"
          :content="datas[vertical].cardCtaContent"
          :url="verticalDatas.formPage"
        />-->
        <atoms-card
          class="text-center mt-16 mb-8"
          rounded="standard"
        >
          <h2 class="text-3.5xl mt-6 font-bold">
            {{ datas[component.activeVertical.value].cardCtaTitle }}
          </h2>
          <p class="text-lg my-4">
            {{ datas[component.activeVertical.value].cardCtaContent }}
          </p>
          <atoms-cta
            :full="false"
            :to="component.verticalDatas.value.formPage"
            class="mb-8 mt-4 mx-auto"
          >
            Compare now
          </atoms-cta>
        </atoms-card>

        <p class="text-center text-semantic-surface-on-surface">
          If you’re new to {{ component.activeVertical.value }}, why not start by reading through our list of <a
            :href="strToSlug(component.activeVertical.value)"
            class="text-semantic-surface-on-surface underline"
          >common FAQs.</a>
        </p>
      </div>
    </section>

    <!--TODO: MoleculesStickyCta-->
    <!--<MoleculesStickyCta v-if="verticalDatas.value.stickyCta" />-->
  </div>
</template>

<script setup>
import { storeToRefs } from 'pinia'
import _isEmpty from 'underscore/cjs/isEmpty.js'
import { usePostsStore } from '~/stores/posts'
import { GUIDES_INDEX_LINKS } from '~/helpers/constants'
import { VERTICAL } from '@/helpers/vertical.constants'

defineOptions({
  name: 'Guides'
})

const props = defineProps({
  imageLazyLoad: {
    type: Boolean,
    default: false
  },
  imageLazyLoadIgnoreMaxIndex: {
    type: Number,
    default: 3
  }
})

const $route = useRoute()
const postsStore = usePostsStore()

const { GET_POSTS, GET_ACTIVE_VERTICAL, GET_MAX_POSTS, GET_POST_PERPAGE } = storeToRefs(postsStore)
await postsStore.initialize()

const strToSlug = str => {
  if (str === VERTICAL.TRAVEL_INSURANCE) {
    return VERTICALS[VERTICAL.TRAVEL_INSURANCE].url
  }

  return `/${str.toLowerCase().replace(/ /g, '-')}/#faq`
}

const datas = {
  [VERTICAL.HEALTH_INSURANCE]: {
    title: 'Health Insurance',
    coverImage: '/images/products/health/health-hero-image.svg',
    cardCtaTitle: 'Need health insurance',
    cardCtaContent: 'It takes less than two minutes to get a comparison',
    seoTitle: 'Private Health Insurance Guides | Compare Club',
    description: 'Not sure where to start with private health insurance? Find your answers in our easy-to-follow guides, no matter your age, life stage or health needs',
    navHasCallCta: true,
    meta: {
      title: 'Health Insurance Guides | Compare Club',
      description: 'Learn about health insurancewith our range of guides so that you can make the best decision reagrding a health insurance possible. Click here. ',
      ogUrl: 'https://compareclub.com.au/health-insurance/guides/',
      canonical: 'https://compareclub.com.au/health-insurance/guides/'
    }
  },
  [VERTICAL.LIFE_INSURANCE]: {
    title: 'Life Insurance',
    coverImage: '/images/products/life/life-hero-image.svg',
    cardCtaTitle: 'Need life insurance?',
    cardCtaContent: 'It takes less than two minutes to get a comparison',
    seoTitle: 'Life Insurance Guides | Compare Club',
    description: 'Looking to protect your family from the unexpected? Read our easy-to follow guides on everything from different types of cover to pre-existing conditions.',
    navHasCallCta: true,
    meta: {
      title: 'Life Insurance Guides | Compare Club',
      description: 'Learn about life insurance with our range of guides so that you can make the best decisions for life insurance. Click here. ',
      ogUrl: 'https://compareclub.com.au/life-insurance/guides/',
      canonical: 'https://compareclub.com.au/life-insurance/guides/'
    }
  },
  [VERTICAL.ENERGY]: {
    title: 'Electricity and Gas',
    coverImage: '/images/products/energy/energy-hero-image.svg',
    cardCtaTitle: 'Looking for cheaper energy?',
    cardCtaContent: 'It takes less than two minutes to get a comparison.',
    seoTitle: 'Electricity and Gas Guides: Learn How To Get The Best Deals',
    description: 'Find out how to save hundreds on your energy bills with our easy-to-follow guides. Get tips and tricks to save when comparing energy plans.',
    navHasCallCta: false,
    meta: {
      title: 'Energy Guides | Compare Club',
      description: 'Learn about energy with our range of guides so that you can make the best decision reagrding a energy possible. Click here.',
      ogUrl: 'https://compareclub.com.au/energy/guides/',
      canonical: 'https://compareclub.com.au/energy/guides/'
    }
  },
  [VERTICAL.HOME_LOANS]: {
    title: 'Home Loans',
    coverImage: '/images/products/home/home-hero-image.svg',
    cardCtaTitle: 'Looking for a home loan?',
    cardCtaContent: 'It takes less than two minutes to get a comparison.',
    seoTitle: 'Essential Guides To Home Loans And Refinancing In Australia | Compare Club',
    description: 'First time buyer? Refinancing? Buying an investment property? Read our easy-to-follow guides and get the best deal on your home loan.',
    navHasCallCta: true,
    meta: {
      title: 'Home Loan Guides | Compare Club',
      description: 'Learn about home loans with our range of guides so that you can make the best decision reagrding a home loan possible. Click here. ',
      ogUrl: 'https://compareclub.com.au/home-loans/guides/',
      canonical: 'https://compareclub.com.au/home-loans/guides/'
    }
  },
  [VERTICAL.CREDIT_CARDS]: {
    title: 'Credit Cards',
    coverImage: '/images/products/health/health-hero-image.svg',
    cardCtaTitle: 'Need personal finance?',
    cardCtaContent: 'It takes less than two minutes to get a comparison',
    seoTitle: 'Personal Finance Guides | Make the smartest lending choices',
    description: 'Need help with choosing the right credit card or personal loan? Our guides show you how to keep your cash flow steady while your repayments stay low.',
    navHasCallCta: true,
    meta: {
      title: 'Compare Club: Health & Life Insurance, Energy, Loans & More',
      description: 'Do your household bills need saving? Compare, change and save money on your health insurance, energy bills, home loans and life cover.',
      ogUrl: 'https://compareclub.com.au/credit-cards/guides/',
      canonical: 'https://compareclub.com.au/credit-cards/guides/'
    }
  },
  [VERTICAL.CAR_INSURANCE]: {
    title: 'Car Insurance',
    coverImage: '/images/products/car-insurance/car-insurance-hero-image.svg',
    cardCtaTitle: 'Need car insurance?',
    cardCtaContent: 'It takes less than two minutes to get a comparison',
    seoTitle: 'Personal Finance Guides | Make the smartest lending choices',
    description: 'Need help with choosing the right credit card or personal loan? Our guides show you how to keep your cash flow steady while your repayments stay low.',
    navHasCallCta: true,
    meta: {
      title: 'Compare Club: Health & Life Insurance, Energy, Loans & More',
      description: 'Do your household bills need saving? Compare, change and save money on your health insurance, energy bills, home loans and life cover.',
      ogUrl: 'https://compareclub.com.au/car-insurance/guides/',
      canonical: 'https://compareclub.com.au/car-insurance/guides/'
    }
  },
  [VERTICAL.TRAVEL_INSURANCE]: {
    title: 'Travel Insurance',
    coverImage: '/images/products/health/health-hero-image.svg',
    cardCtaTitle: 'Need travel insurance',
    cardCtaContent: 'It takes less than two minutes to get a comparison',
    seoTitle: 'Travel Insurance Guides | Compare Club',
    description: 'Not sure where to start with travel insurance? Find your answers in our easy-to-follow guides, no matter your age, life stage or health needs',
    navHasCallCta: true,
    meta: {
      title: 'Travel Insurance Guides | Compare Club',
      description: 'Learn about travel insurance with our range of guides so that you can make the best decision reagrding a travel insurance possible. Click here. ',
      ogUrl: 'https://compareclub.com.au/travel-insurance/guides/',
      canonical: 'https://compareclub.com.au/travel-insurance/guides/'
    }
  }
}

if (!datas[GET_ACTIVE_VERTICAL.value]) {
  throw createError({
    statusCode: 404,
    statusMessage: `${GET_ACTIVE_VERTICAL.value} guides are coming soon`,
    fatal: false
  })
}

const component = computed(() => {
  const postsData = ref(GET_POSTS.value)
  const activeVertical = ref(GET_ACTIVE_VERTICAL.value)
  const verticalDatas = ref(VERTICALS[GET_ACTIVE_VERTICAL.value])
  return {
    postsData,
    activeVertical,
    verticalDatas
  }
})

const guidesIndexLinks = computed(() => {
  const { enableAllGuides } = useEnv()
  let guidesLink = GUIDES_INDEX_LINKS
  if (!enableAllGuides) {
    guidesLink = GUIDES_INDEX_LINKS.filter(function (index) {
      return index.name !== VERTICAL.CAR_INSURANCE
    })
  }
  return guidesLink
})

const PAGE_DETAILS = {
  title: datas[GET_ACTIVE_VERTICAL.value].meta.title,
  description: datas[GET_ACTIVE_VERTICAL.value].meta.description,
  ogUrl: datas[GET_ACTIVE_VERTICAL.value].meta.ogUrl,
  canonical: datas[GET_ACTIVE_VERTICAL.value].meta.canonical,
  ogType: 'corporate'
}

generateMeta({
  title: PAGE_DETAILS.title,
  ogTitle: PAGE_DETAILS.title,
  description: PAGE_DETAILS.description,
  ogDescription: PAGE_DETAILS.description,
  ogUrl: PAGE_DETAILS.ogUrl,
  canonical: PAGE_DETAILS.canonical,
  ogImage: '',
  ogType: PAGE_DETAILS.ogType
})

useJsonld(() => {
  const _path = trailingSlash($route.path)

  return {
    '@context': 'https://schema.org',
    '@graph': [
      GENERATE_WEBPAGE_SCHEMA({
        page: _path,
        pageTitle: PAGE_DETAILS.title,
        pageDescription: PAGE_DETAILS.description,
        aboutPath: '/#organization',
        mainEntityPath: '/#organization',
        primaryImageOfPagePath: '/#logo',
        breadcrumbPath: `${_path}#breadcrumb`
      }),
      GENERATE_BREADCRUMB_SCHEMA(_path)
    ]
  }
})
</script>